/* eslint-disable react/jsx-no-undef */
import React from "react";
import { useNavigate } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import { useLiff } from "react-liff";
import SecondaryButton from "../../components/button/SecondaryButton";

export default function BingoReward() {

    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;

    const [windowDimensions, setWindowDimensions] = React.useState(
        getWindowDimensions()
    );
    const navigate = useNavigate();

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height,
        };
    }

    return (
        <>
            <TopLogo />
            <div
                style={{
                    background: "#005AAA",
                    minHeight: "calc(100vh - 60px)",
                    paddingTop: "20px"
                }}
            >

                <div className="overflow-y-auto px-[20px]" style={{ height: "calc(100vh - 370px)" }}>
                    {/* <InfiniteScroll
                        loadMore={fetchItems}
                        hasMore={isLoading}
                        loader={loader}
                    > */}
                    <div id="section1" className="px-[10px] py-[15px] bg-lightGray2 mb-[20px] rounded-[6px]">
                        <div className="text-center">
                            <p className="text-blue text-[20px] leading-[19.2px] px-[16px]">24</p>
                            <p className="text-gray text-[20px] leading-[19.2px] px-[16px]">รับได้ถึงวันที่: 23/05/2565
                            </p>
                        </div>

                        <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[15px]" />

                        <div className="flex justify-between ">
                            <p className="text-darkGray text-[16px] leading-[19.2px] px-[16px]">วันที่ออกใบเสร็จ</p>
                            <p className="text-lightBlue2 text-[16px] leading-[19.2px] px-[16px]">11</p>
                        </div>

                        <p className="text-darkGray text-[16px] leading-[19.2px] px-[16px] mt-[15px]">สินค้า</p>


                        <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[20px]" />



                        <br></br>
                    </div>

                </div>
            </div>
            <div className="bg-white w-full" style={{
                position: 'fixed',
                bottom: 0,
                padding: '20px'
            }}>
                <div className="place-content-center">
                    <SecondaryButton
                        fullWidth
                        variant="outlined"
                        onClick={() => navigate(-1)}
                    >
                        <p>ย้อนกลับ</p>
                    </SecondaryButton>
                </div>

            </div>
        </>
    );
}
